(function ($, Drupal, drupalSettings) {
  'use strict';

  function IEImageMultiplyFallback(bgImageClassName) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isIEEdge = window.navigator.userAgent.indexOf('Edge') > -1;

    if (isIE11 === true || isIEEdge === true) {
      $(bgImageClassName).each(function () {
        var bgImage = $(this);
        $(bgImage).css('opacity', .8);
      });
    }
  }

  function IEObjectFit(bgImageClassName) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isIEEdge = window.navigator.userAgent.indexOf('Edge') > -1;

    if (isIE11 === true || isIEEdge === true) {
      $(bgImageClassName).each(function () {
        var container = $(this);
        var imgUrl = container.find('img').prop('src');
        if (imgUrl) {
          container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
        }
      });
    }
  }

  Drupal.behaviors.IEPartnerImageMultiplyFallback = {
    attach: function (context, settings) {
      $('.kr-partner-hero__background-overlay', context).each(function () {
        IEImageMultiplyFallback('.kr-partner-hero__background-overlay');
      });
    }
  };

  Drupal.behaviors.IEObjectFitPartnerPageHero = {
    attach: function (context, settings) {
      $('.kr-partner-page-hero__content-wrapper', context).each(function () {
        IEObjectFit('.kr-partner-page-hero__background-image');
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
